const OrgBanner = ({
  name,
  description,
  primaryColor,
  imageUrl,
  secondaryColor,
  variant,
}: {
  name: string
  description?: string
  primaryColor?: string
  secondaryColor?: string
  imageUrl?: string
  variant?: 'mini' | undefined
}) => (
  <section
    className="align-center relative flex flex-col justify-center rounded-sm p-4"
    style={{
      backgroundColor: primaryColor ?? 'rgb(189, 153, 254)',
    }}
  >
    {variant !== 'mini' && imageUrl && (
      <img
        alt={name}
        src={imageUrl}
        className="mb-8 h-16 w-16 rounded-sm"
        style={{
          backgroundColor: secondaryColor ?? 'black',
        }}
      />
    )}
    <pre style={{ color: secondaryColor ?? 'black' }}>
      {name}
    </pre>
    {variant !== 'mini' && description && (
      <pre
        style={{
          color: secondaryColor ?? 'black',
          opacity: 0.75,
        }}
      >
        {description}
      </pre>
    )}
  </section>
)

export default OrgBanner
